/**
*
* useAllGroupsState
*
*/

import { useEffect, useState } from 'react';
import useUiControl from 'containers/UiControl/useUiControl.js';
import isOwnGroup from './isOwnGroup.js';

function isNonMemberGroup(g) {
  return g && g.permissions && !isOwnGroup(g);
}

function noop() {}

function useAllGroupsState(checkGroups, uiProp, canShowAll = true) {
  const [showAllGroups, setShowAllGroups] = useState(false);
  const [uiValue, setUiValue] = useUiControl(uiProp);
  // show initially if current community if not own group
  const initial = canShowAll && checkGroups.some((g) => isNonMemberGroup(g));

  useEffect(() => {
    if (initial) {
      setShowAllGroups(true);
    }
  }, [initial]);

  if (!canShowAll) {
    // users without all-groups read access can never reach the all-groups view
    return [false, noop];
  }
  return uiProp ? [uiValue, setUiValue] : [showAllGroups, setShowAllGroups];
}

export default useAllGroupsState;
